import { ErrorProps } from "Hooks/useProduct/interface";
import { ProductsData } from "Hooks/useProducts/interface";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { getProducts } from "Requests/Products";
import { validateArrayType } from "Utils/Arrays";
import { createToast } from "Utils/toastFunc";

export const useProductList = () => {
  const [pageSelected, setPageSelected] = useState(1);
  const [enable, setEnable] = useState(false);

  const [filters, setFilters] = useState({
    categories: "1,2,3",
  });

  useEffect(() => {
    // setEnable(true);
  }, [filters]);
  const { data, isLoading, isError, error } = useQuery<
    ProductsData,
    ErrorProps
  >(
    ["products", filters, pageSelected],
    () =>
      getProducts({
        page: pageSelected,
        filters: { ...filters, services: "1" },
        searchBudget: true,
      }),
    {
      enabled: enable,
      refetchOnWindowFocus: false,
      onError: (errorRes: ErrorProps) => createToast("error", errorRes.message),
    }
  );

  const handleClearData = () => {
    setPageSelected(1);
    searchProducts({
      categories: "1,2,3",
      search: "",
      subcategories: "",
    });
  };

  const setNewPage = (page: number) => {
    setPageSelected(page);
  };

  const enableData = () => setEnable(true);

  const setProductFilters = (searchFilter: any) => {
    setPageSelected(1);
    setFilters({ ...searchFilter });
  };

  const searchProducts = (searchFilters: any) => {
    setProductFilters(searchFilters);
    enableData();
  };

  return {
    loadingProducts: isLoading,
    getProducts: searchProducts,
    productsList: validateArrayType(data?.data) ? data?.data : [],
    fetchNewPage: setNewPage,
    pageSelected,
    productsPagination: {
      ...data?.pagination,
    },
    handleClearData,
    filtersSelected: filters,
  };
};
